export const hanldeSortingArray = (array, field, type, order) => {
    let sortedArray = [...array];

    if (!!field && type === 'Text') {
        sortedArray.sort((a, b) => {
            const ipA = a[field] || "";
            const ipB = b[field] || "";
            const returnResult = ipA.localeCompare(ipB);
            return order === 'asc' ? returnResult : -returnResult;
        })
    } else if (type === 'Number') {
        sortedArray.sort((a, b) => {
            const numA = parseInt(a[field]) || '';
            const numB = parseInt(b[field]) || '';
            const returnNumResult = numB - numA //.localeCompare(numB)
            return order === 'asc' ? returnNumResult : -returnNumResult;
        })
    } else if (type === 'Status') {
        sortedArray.sort((a, b) => {
            const numA = a[field] || '';
            const numB = b[field] || '';
            const returnStatusResult = numB - numA;
            return order === 'asc' ? returnStatusResult : -returnStatusResult;
        })
    }
    return sortedArray;
}